module.exports = __webpack_public_path__ + "static/media/star.ba972ba8.svg";